import script from "./GoodsItemAction.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoodsItemAction.vue?vue&type=script&lang=ts&setup=true"

import "./GoodsItemAction.vue?vue&type=style&index=0&id=347568ac&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347568ac"]])

export default __exports__